export const SINGLE_PHOTOGRAPHER_FETCH_REQUEST = 'single-photographer-fetch-request';
export const SINGLE_PHOTOGRAPHER_FETCH_SUCCESS = 'single-photographer-fetch-success';
export const SINGLE_PHOTOGRAPHER_FETCH_FAILURE = 'single-photographer-fetch-failure';